import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  TypeSignUpApplicationRequest,
  TypeSignUpApplicationResponse,
} from '../Hooks/useSignUpApplication'

type SignUpState = {
  signUp: State
}

export type TypeVerifiedFrom = 'verified-address' | 'verified-identification' | 'n/a'

export type State = {
  signupApplication?: TypeSignUpApplicationRequest
  signupVerification?: TypeSignUpApplicationResponse
  verifiedFrom?: TypeVerifiedFrom
  numberOfAttemptsToVerify?: number
  newUserBetAccount?: number
  isNewUserAutoLoggedIn?: boolean
  hasUserStartedSignup?: boolean
}

const initialState: State = {}

const slice = createSlice({
  name: 'sign-up',
  initialState: initialState,
  reducers: {
    setSignupApplication(state, action: PayloadAction<TypeSignUpApplicationRequest | undefined>) {
      state.signupApplication = action.payload
    },
    setSignupVerification(state, action: PayloadAction<TypeSignUpApplicationResponse | undefined>) {
      state.signupVerification = action.payload
    },
    setVerifiedFrom(state, action: PayloadAction<TypeVerifiedFrom | undefined>) {
      state.verifiedFrom = action.payload
    },
    setNumberOfAttemptsToVerify(state) {
      if (state.numberOfAttemptsToVerify === undefined) {
        state.numberOfAttemptsToVerify = 0
      } else {
        state.numberOfAttemptsToVerify += 1
      }
    },
    setNewUserBetAccount(state, action: PayloadAction<number | undefined>) {
      state.newUserBetAccount = action.payload
    },
    setIsNewUserAutoLoggedIn(state, action: PayloadAction<boolean | undefined>) {
      state.isNewUserAutoLoggedIn = action.payload
    },
    setSignupNewSession() {
      return initialState
    },
    setHasUserStartedSignup(state, action: PayloadAction<boolean | undefined>) {
      state.hasUserStartedSignup = action.payload
    },
  },
})

export const {
  setSignupApplication,
  setSignupVerification,
  setVerifiedFrom,
  setNumberOfAttemptsToVerify,
  setNewUserBetAccount,
  setIsNewUserAutoLoggedIn,
  setSignupNewSession,
  setHasUserStartedSignup,
} = slice.actions

export default slice.reducer

export function getSignUpState(state: SignUpState): State | undefined {
  return state.signUp
}
